import { useEffect, useState } from 'react';
import { isEmpty } from 'ramda';

import {
  findProgramByAssetId,
  findSubjectAsset,
  getAssetsSubset,
  getProgramAssetsIds,
  removeDuplicates,
  SubjectsMap,
} from 'shared/lib/utils';
import {
  useGetUserAssetsQuery,
  useGetUserProgramsQuery,
} from 'shared/api/retail';
import { AuthService } from 'shared/lib/keycloak';

export const useSubjectsFromProductMap = (
  productsMap: Record<string, string>,
) => {
  const [subjects, setSubjects] = useState<SubjectsMap>();

  const teacherBk = AuthService.getUserBk();

  const { data: userAssets } = useGetUserAssetsQuery(teacherBk);
  const { data: userPrograms } = useGetUserProgramsQuery(teacherBk);

  useEffect(() => {
    if (!userPrograms || !userAssets) return;

    const uniqueProducts = removeDuplicates(productsMap);
    const uniqueProductsIds = Object.keys(uniqueProducts);

    const subjectsFromProductMap = uniqueProductsIds.reduce<SubjectsMap>(
      (acc, productId) => {
        const productProgram = findProgramByAssetId(userPrograms, productId);

        if (!productProgram) return acc;

        const programAssetsIds = getProgramAssetsIds(productProgram);
        const programAssetsWithMetadata = getAssetsSubset(
          userAssets,
          programAssetsIds,
        );
        const subjectAsset = findSubjectAsset(programAssetsWithMetadata);

        if (!subjectAsset) return acc;

        acc[productId] = subjectAsset.metadata.curriculum_app_display?.subject;

        return acc;
      },
      {},
    );

    if (isEmpty(subjectsFromProductMap)) return;

    setSubjects(subjectsFromProductMap);
  }, [productsMap, userPrograms, userAssets]);

  return subjects;
};
